import { Tooltip } from 'antd';
import { useAppDispatch, useAppTranslation } from 'app/hooks';
import Typo from 'consts/typography';
import { PnLResponse } from 'models';
import { useState } from 'react';
import { IoInformationCircleOutline } from 'react-icons/io5';
import { formatAmountV2 } from 'utils/formatAmount';
import ListBet from '../Modals/ListBet';
interface ProfitAndLossProps {
  pnlType: 'ATR' | 'TODAY';
  pnl: PnLResponse;
  showAtr?: boolean;
}

const ProfitAndLoss: React.FunctionComponent<ProfitAndLossProps> = ({
  pnlType,
  pnl,
  showAtr = true,
}) => {
  const t = useAppTranslation();
  const [showListBetType, setShowListBetType] = useState<'win' | 'lose' | null>(null);
  const dispatch = useAppDispatch();

  const renderTooltip = () => {
    return (
      <div>
        <div className="pnl-tooltip">
          <span className={`${Typo.p5} `}>{t('pnl.win')}:</span>
          <span
            className={`${Typo.p5} positive font-bold cursor-pointer underline `}
            onClick={() => setShowListBetType('win')}
          >
            +{formatAmountV2(pnl?.winAmount, 2)}
          </span>{' '}
        </div>
        <div className="pnl-tooltip">
          <span className={`${Typo.p5} `}>{t('pnl.lose')}: </span>
          <span
            className={`${Typo.p5} negative font-bold cursor-pointer underline `}
            onClick={() => setShowListBetType('lose')}
          >
            -{formatAmountV2(pnl?.loseAmount, 2)}
          </span>
        </div>
      </div>
    );
  };

  const colorPnl = () => {
    if (!pnl || parseFloat(pnl.pnl) === 0) {
      return '';
    }
    const numPnl = parseFloat(pnl.pnl);
    if (numPnl > 0) {
      return 'positive';
    }
    return 'negative';
  };

  const renderPnl = () => {
    if (!pnl || parseFloat(pnl.pnl) === 0) {
      return '0.00';
    }
    const numPnl = parseFloat(pnl.pnl);
    if (numPnl > 0) {
      return `+${formatAmountV2(pnl?.pnl, 2)}`;
    }
    return `${formatAmountV2(pnl?.pnl, 2)}`;
  };

  return (
    <>
      <div className="flex flex-row items-center gap-2">
        <span className={`primary-text-color ${Typo.p5} ${colorPnl()} font-bold `}>
          {showAtr ? renderPnl() : '******'} $
        </span>
        <Tooltip
          placement="bottomRight"
          title={renderTooltip()}
          showArrow={false}
          zIndex={!!showListBetType ? -1000 : 1000}
        >
          <IoInformationCircleOutline className={`w-6 h-6 grey-text-color`} />
        </Tooltip>
      </div>
      <ListBet type={showListBetType} onClose={() => setShowListBetType(null)} pnlType={pnlType} />
    </>
  );
};

export default ProfitAndLoss;
